import { render, staticRenderFns } from "./RejectedAmount.vue?vue&type=template&id=877b9008&scoped=true&lang=pug&"
import script from "./RejectedAmount.vue?vue&type=script&lang=js&"
export * from "./RejectedAmount.vue?vue&type=script&lang=js&"
import style0 from "./RejectedAmount.vue?vue&type=style&index=0&id=877b9008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877b9008",
  null
  
)

export default component.exports